import { gql } from '@apollo/client';

export const fetchProductsForInvoiceGroup = gql`
  query fetchProductsForInvoiceGroup($id: ID!) {
    invoiceGroup(id: $id) {
      id
      products {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        nodes {
          billingFrequency
          billingStatus
          entitlementNumber
          id
          latestPeriodEndDate
          latestPeriodStartDate
          productName
          productId
        }
      }
    }
  }
`;
